// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"179":"main","328":"admin","378":"user","501":"public"}[chunkId] || chunkId) + "-legacy." + {"86":"b027eb3e","179":"5ef15cf2","328":"33d21099","378":"b4fd3bcc","501":"b98dfcf8","660":"dda847fa","830":"2acf98e8"}[chunkId] + ".js";
};